var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.201,
    height: 15,
    viewBox: "0 0 12.201 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-2.833 -0.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(3.333 0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.733,1.167h5.6a.5.5,0,0,1,.354.146l4.2,4.2a.5.5,0,0,1,.146.354v8.4a1.9,1.9,0,0,1-1.9,1.9h-8.4a1.9,1.9,0,0,1-1.9-1.9V3.066A1.9,1.9,0,0,1,4.733,1.167Zm5.393,1H4.733a.9.9,0,0,0-.9.9v11.2a.9.9,0,0,0,.9.9h8.4a.9.9,0,0,0,.9-.9V6.074Z",
    transform: "translate(-3.333 -1.667)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M15.867,6.367h-4.2a.5.5,0,0,1-.5-.5v-4.2a.5.5,0,1,1,1,0v3.7h3.7a.5.5,0,0,1,0,1Z",
    transform: "translate(-4.666 -1.667)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M5.6.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.6a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.6.5Z",
    transform: "translate(2.8 7.7)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M5.6.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.6a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.6.5Z",
    transform: "translate(2.8 10.5)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M8.066,8h-1.4a.5.5,0,0,1,0-1h1.4a.5.5,0,0,1,0,1Z",
    transform: "translate(-3.866 -2.6)",
    fill: "#fc3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabTransaction);
export default __webpack_public_path__ + "static/media/tab-transaction.4fd0fa4746408abd82eb8c062672b8d7.svg";
export { ForwardRef as ReactComponent };